/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { Loading } from '@/components';
import { Card, Container } from 'reactstrap';
import './style.scss';
import { Link, useParams, useHistory } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { colors } from '@/styles/colors';
import EventClose from '@/model/EventClose';
import dayjs from 'dayjs';
import { ReactComponent as LocationPin } from '@/assets/images/svg/locationPinNoFill.svg';
import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import SuperButton from '@/components/sharedComponents/SuperButton';
import { toPercentage } from '@/helpers/common/amount';

interface ReportTitle {
  title: string;
}

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

interface HomeContainerProps {
  state: States;
  eventState?: EventClose;
  closeEvent: () => void;
}

export const HomeContainer: React.FC<HomeContainerProps> = ({ state, eventState, closeEvent }) => {
  const history = useHistory();
  const { id: eventId } = useParams<{ id: string }>();

  const mountContractorText = (): string => {
    let s = 'Contratantes: ';
    if (
      eventState &&
      eventState.header &&
      eventState.header.contractors &&
      eventState.header.contractors.length > 0
    ) {
      eventState.header.contractors.forEach((data, index) => {
        if (index > 0) {
          s += ' / ';
        }
        s += data;
      });
    }
    return s;
  };

  const sumAmountGeneral = (): number => {
    let amount = 0;
    if (eventState && eventState.generals && eventState.generals.length > 0) {
      eventState.generals.forEach(data => {
        amount += data.value;
      });
    }
    return amount;
  };

  const ReportCards = (): JSX.Element => {
    const newReports: ReportTitle[] = [{ title: 'Receitas' }, { title: 'Despesas' }];

    return (
      <React.Fragment>
        {newReports.map((report, index) => (
          <Card
            key={`Card-Report-${index}`}
            className="report-menu-card card-no-border"
            style={{
              backgroundColor: '#FFFFFF',
              color: '#000000',

              whiteSpace: 'normal',
              textAlign: 'center',
              maxWidth: '180px',
              padding: 'initial',
              minHeight: '100px',
              justifyContent: 'center',
            }}
            onClick={() => {
              if (report.title === 'Receitas') {
                history.push(`/financial/event-close/income/${eventId}`);
              } else if (report.title === 'Despesas') {
                history.push(`/financial/event-close/expense/${eventId}`);
              }
            }}
          >
            {report.title}
          </Card>
        ))}
      </React.Fragment>
    );
  };

  const sumTotalCollected = (): number => {
    let n = 0;
    if (eventState && eventState.generalCollections && eventState.generalCollections.length > 0) {
      eventState.generalCollections.forEach(data => {
        n += data.total;
      });
    }
    return n;
  };

  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Container className="mainContainer" fluid={true}>
        {eventState ? (
          <>
            <div className="d-flex justify-content-between">
              <div className="pageTitle d-flex" style={{ margin: 0 }}>
                <Link to={`${process.env.PUBLIC_URL}/dashboard/event`}>
                  <ArrowLeft color={colors.black} className="arrow-left" />
                </Link>
                <h5 className="ml-3 mb-0 mt-2 pageTitle">
                  {eventState.header.name} -{' '}
                  {eventState.header.startDate
                    ? dayjs(eventState.header.startDate).format('DD/MM/YYYY')
                    : 'Sem data'}
                </h5>
              </div>
            </div>
            <div className="d-flex">
              <LocationPin style={{ transform: 'scale(0.9)' }} color={colors.black} />
              <div
                className="text-darkgray-regular"
                style={{ marginLeft: '15px', marginTop: '-3px' }}
              >
                {eventState.header.city}
              </div>
            </div>

            <div className="d-flex">
              <div className="text-darkgray-regular">{mountContractorText()}</div>
            </div>
          </>
        ) : (
          <div className="pageTitle d-flex mb-5">
            <Link to={`${process.env.PUBLIC_URL}/dashboard/event`}>
              <ArrowLeft color={colors.black} className="arrow-left" />
            </Link>
            <h5 className="ml-3 mb-0 mt-2 pageTitle">Fechamento de evento</h5>
          </div>
        )}

        <div>
          <h6 className="mb-4 collapseTableText">Arrecadação geral do evento</h6>
          <Card
            className="mb-5 card-no-border customTableScroll"
            style={{ border: 'none', overflow: 'auto' }}
          >
            <CustomTable
              theme="secondary"
              columns={[
                {
                  name: 'Data',
                  selector: row => row.date,
                },
                {
                  name: 'Evento',
                  selector: row => row.name,
                },
                {
                  name: 'Ingressos',
                  selector: row => row.tickets,
                },
                {
                  name: 'Valor',
                  selector: row => row.saleValue,
                },
                {
                  name: 'Taxa',
                  selector: row => row.fee,
                },
                {
                  name: 'Valor',
                  selector: row => row.total,
                },
              ]}
              data={
                eventState &&
                eventState.generalCollections &&
                eventState.generalCollections.length > 0
                  ? eventState.generalCollections.map(item => ({
                      date: dayjs(item.date).format('DD/MM/YYYY') || '-----',
                      name: item.name || '-----',
                      tickets: item.tickets || 0,
                      saleValue: item.saleValue ? toCurrency(item.saleValue) : 0,
                      fee: item.fee ? toCurrency(item.fee) : 0,
                      total: item.fee ? toCurrency(item.total) : 0,
                    }))
                  : []
              }
              numberRowsPerPage={10}
              progressPending={false}
            />
            <hr className="mb-0" style={{ minWidth: '1080px' }} />
            <div
              style={{
                padding: '30px 40px',
                gap: '40px',
              }}
              className="d-flex justify-content-center"
            >
              <>
                <div className="d-flex">
                  <div className="mr-1 text-small-gray-regular">Total arrecadação:</div>
                  <div className="text-small-black-600">{toCurrency(sumTotalCollected())}</div>
                </div>
              </>
            </div>
          </Card>
        </div>
        {eventState && eventState.tickets && eventState.tickets.length > 0 && (
          <Fragment>
            <div>
              <h5 className="mb-4 collapseTableText">Ingressos</h5>
            </div>
            {eventState.tickets.map(ticket => (
              <div key={`ticket-${ticket.gateway}-${ticket.fisicalSale}`}>
                <h6 className="collapseTableText" style={{ paddingTop: 0 }}>{`Receitas com venda ${
                  ticket.fisicalSale ? 'física' : 'online'
                }`}</h6>
                <h6
                  className="collapseTableText"
                  style={{ paddingTop: 0 }}
                >{`Gateway ${ticket.gateway}`}</h6>
                <Card
                  className="mb-5 card-no-border customTableScroll"
                  style={{ border: 'none', overflow: 'auto' }}
                >
                  <CustomTable
                    theme="secondary"
                    columns={[
                      {
                        name: 'Forma de pagamento',
                        selector: row => row.paymentForm,
                      },
                      {
                        name: 'Valor',
                        selector: row => row.value,
                        width: '120px',
                      },
                      {
                        name: 'Receita Taxas',
                        selector: row => row.fee,
                      },
                      {
                        name: 'Total Taxas',
                        selector: row => row.total,
                        width: '120px',
                      },
                      {
                        name: 'Total liquido',
                        selector: row => row.netValue,
                      },
                      {
                        name: 'PIX',
                        selector: row => row.pixValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Visa',
                        selector: row => row.visaValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Master',
                        selector: row => row.masterValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Elo',
                        selector: row => row.eloValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Hipercard',
                        selector: row => row.hipercardValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Amex',
                        selector: row => row.amexValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Cabal',
                        selector: row => row.cabalValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Banricompras',
                        selector: row => row.banricomprasValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Volus',
                        selector: row => row.volusValueFee,
                        width: '250px',
                      },
                    ]}
                    data={
                      ticket.saleValues && ticket.saleValues.length > 0
                        ? ticket.saleValues.map(item => ({
                            paymentForm: item.paymentForm || '-----',
                            value: item.value ? toCurrency(item.value) : 0,
                            fee: toCurrency(item.administrativeFees + item.paymentFees),
                            total: toCurrency(item.total),
                            netValue: toCurrency(item.netValue),
                            pixValueFee:
                              item.pixValue && item.pixValue > 0
                                ? `${toCurrency(item.pixValue)} X ${toPercentage(
                                    item.pixFee,
                                  )}% = ${toCurrency(item.pixValueFee)}`
                                : '',
                            visaValueFee:
                              item.visaValue && item.visaValue > 0
                                ? `${toCurrency(item.visaValue)} X ${toPercentage(
                                    item.visaFee,
                                  )}% = ${toCurrency(item.visaValueFee)}`
                                : '',
                            masterValueFee:
                              item.masterValue && item.masterValue > 0
                                ? `${toCurrency(item.masterValue)} X ${toPercentage(
                                    item.masterFee,
                                  )}% = ${toCurrency(item.masterValueFee)}`
                                : '',
                            eloValueFee:
                              item.eloValue && item.eloValue > 0
                                ? `${toCurrency(item.eloValue)} X ${toPercentage(
                                    item.eloFee,
                                  )}% = ${toCurrency(item.eloValueFee)}`
                                : '',
                            hipercardValueFee:
                              item.hipercardValue && item.hipercardValue > 0
                                ? `${toCurrency(item.hipercardValue)} X ${toPercentage(
                                    item.hipercardFee,
                                  )}% = ${toCurrency(item.hipercardValueFee)}`
                                : '',
                            amexValueFee:
                              item.amexValue && item.amexValue > 0
                                ? `${toCurrency(item.amexValue)} X ${toPercentage(
                                    item.amexFee,
                                  )}% = ${toCurrency(item.amexValueFee)}`
                                : '',
                            cabalValueFee:
                              item.cabalValue && item.cabalValue > 0
                                ? `${toCurrency(item.cabalValue)} X ${toPercentage(
                                    item.cabalFee,
                                  )}% = ${toCurrency(item.cabalValueFee)}`
                                : '',
                            banricomprasValueFee:
                              item.banricomprasValue && item.banricomprasValue > 0
                                ? `${toCurrency(item.banricomprasValue)} X ${toPercentage(
                                    item.banricomprasFee,
                                  )}% = ${toCurrency(item.banricomprasValueFee)}`
                                : '',
                            volusValueFee:
                              item.volusValue && item.volusValue > 0
                                ? `${toCurrency(item.volusValue)} X ${toPercentage(
                                    item.volusFee,
                                  )}% = ${toCurrency(item.volusValueFee)}`
                                : '',
                          }))
                        : []
                    }
                    numberRowsPerPage={10}
                    progressPending={false}
                  />
                  <hr className="mb-0" style={{ minWidth: '1080px' }} />
                  <div
                    style={{
                      padding: '30px 40px',
                      gap: '40px',
                    }}
                    className="d-flex justify-content-center"
                  >
                    <>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Valor Arrecadado:</div>
                        <div className="text-small-black-600">
                          {toCurrency(ticket.summary.totalValue)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Receita Taxas:</div>
                        <div className="text-small-black-600">
                          {toCurrency(ticket.summary.administrativeFees)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Custo Taxas:</div>
                        <div className="text-small-black-600">
                          {toCurrency(ticket.summary.gatewayFees)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Total Liquido:</div>
                        <div className="text-small-black-600">
                          {toCurrency(ticket.summary.netValue)}
                        </div>
                      </div>
                    </>
                  </div>
                </Card>
              </div>
            ))}
          </Fragment>
        )}

        {eventState && eventState.products && eventState.products.length > 0 && (
          <Fragment>
            <div>
              <h5 className="mb-4 collapseTableText">Bar</h5>
            </div>
            {eventState.products.map(product => (
              <div key={`ticket-${product.gateway}-${product.fisicalSale}`}>
                <h6 className="collapseTableText" style={{ paddingTop: 0 }}>{`Receitas com venda ${
                  product.fisicalSale ? 'física' : 'online'
                }`}</h6>
                <h6
                  className="collapseTableText"
                  style={{ paddingTop: 0 }}
                >{`Gateway ${product.gateway}`}</h6>
                <Card
                  className="mb-5 card-no-border customTableScroll"
                  style={{ border: 'none', overflow: 'auto' }}
                >
                  <CustomTable
                    theme="secondary"
                    columns={[
                      {
                        name: 'Forma de pagamento',
                        selector: row => row.paymentForm,
                      },
                      {
                        name: 'Valor',
                        selector: row => row.value,
                        width: '120px',
                      },
                      {
                        name: 'Receita Taxas',
                        selector: row => row.fee,
                      },
                      {
                        name: 'Total liquido',
                        selector: row => row.netValue,
                      },
                      {
                        name: 'PIX',
                        selector: row => row.pixValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Visa',
                        selector: row => row.visaValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Master',
                        selector: row => row.masterValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Elo',
                        selector: row => row.eloValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Hipercard',
                        selector: row => row.hipercardValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Amex',
                        selector: row => row.amexValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Cabal',
                        selector: row => row.cabalValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Banricompras',
                        selector: row => row.banricomprasValueFee,
                        width: '250px',
                      },
                      {
                        name: 'Volus',
                        selector: row => row.volusValueFee,
                        width: '250px',
                      },
                    ]}
                    data={
                      product.saleValues && product.saleValues.length > 0
                        ? product.saleValues.map(item => ({
                            paymentForm: item.paymentForm || '-----',
                            value: item.value
                              ? toCurrency(item.value + item.administrativeFees + item.paymentFees)
                              : 0,
                            fee: toCurrency(item.producerFees),
                            netValue: toCurrency(item.netValue),
                            pixValueFee:
                              item.pixValue && item.pixValue > 0
                                ? `${toCurrency(item.pixValue)} X ${toPercentage(
                                    item.pixFee,
                                  )}% = ${toCurrency(item.pixValueFee)}`
                                : '',
                            visaValueFee:
                              item.visaValue && item.visaValue > 0
                                ? `${toCurrency(item.visaValue)} X ${toPercentage(
                                    item.visaFee,
                                  )}% = ${toCurrency(item.visaValueFee)}`
                                : '',
                            masterValueFee:
                              item.masterValue && item.masterValue > 0
                                ? `${toCurrency(item.masterValue)} X ${toPercentage(
                                    item.masterFee,
                                  )}% = ${toCurrency(item.masterValueFee)}`
                                : '',
                            eloValueFee:
                              item.eloValue && item.eloValue > 0
                                ? `${toCurrency(item.eloValue)} X ${toPercentage(
                                    item.eloFee,
                                  )}% = ${toCurrency(item.eloValueFee)}`
                                : '',
                            hipercardValueFee:
                              item.hipercardValue && item.hipercardValue > 0
                                ? `${toCurrency(item.hipercardValue)} X ${toPercentage(
                                    item.hipercardFee,
                                  )}% = ${toCurrency(item.hipercardValueFee)}`
                                : '',
                            amexValueFee:
                              item.amexValue && item.amexValue > 0
                                ? `${toCurrency(item.amexValue)} X ${toPercentage(
                                    item.amexFee,
                                  )}% = ${toCurrency(item.amexValueFee)}`
                                : '',
                            cabalValueFee:
                              item.cabalValue && item.cabalValue > 0
                                ? `${toCurrency(item.cabalValue)} X ${toPercentage(
                                    item.cabalFee,
                                  )}% = ${toCurrency(item.cabalValueFee)}`
                                : '',
                            banricomprasValueFee:
                              item.banricomprasValue && item.banricomprasValue > 0
                                ? `${toCurrency(item.banricomprasValue)} X ${toPercentage(
                                    item.banricomprasFee,
                                  )}% = ${toCurrency(item.banricomprasValueFee)}`
                                : '',
                            volusValueFee:
                              item.volusValue && item.volusValue > 0
                                ? `${toCurrency(item.volusValue)} X ${toPercentage(
                                    item.volusFee,
                                  )}% = ${toCurrency(item.volusValueFee)}`
                                : '',
                          }))
                        : []
                    }
                    numberRowsPerPage={10}
                    progressPending={false}
                  />
                  <hr className="mb-0" style={{ minWidth: '1080px' }} />
                  <div
                    style={{
                      padding: '30px 40px',
                      gap: '40px',
                    }}
                    className="d-flex justify-content-center"
                  >
                    <>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Valor Arrecadado:</div>
                        <div className="text-small-black-600">
                          {toCurrency(product.summary.totalValue)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Receita Taxas:</div>
                        <div className="text-small-black-600">
                          {toCurrency(product.summary.producerFees)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Custo Taxas:</div>
                        <div className="text-small-black-600">
                          {toCurrency(product.summary.gatewayFees)}
                        </div>
                      </div>
                      <div className="d-flex">
                        <div className="mr-1 text-small-gray-regular">Total Liquido:</div>
                        <div className="text-small-black-600">
                          {toCurrency(product.summary.netValue)}
                        </div>
                      </div>
                    </>
                  </div>
                </Card>
              </div>
            ))}
          </Fragment>
        )}

        <div>
          <h6 className="mb-4 collapseTableText">Receitas diversas</h6>
          <Card
            className="mb-5 card-no-border customTableScroll"
            style={{ border: 'none', overflow: 'auto' }}
          >
            <CustomTable
              theme="secondary"
              columns={[
                {
                  name: 'Descrição',
                  selector: row => row.description,
                },
                {
                  name: 'Qtd',
                  selector: row => row.amount,
                },
                {
                  name: 'Valor',
                  selector: row => row.value,
                },
              ]}
              data={
                eventState && eventState.generals && eventState.generals.length > 0
                  ? eventState.generals.map(item => ({
                      description: item.description || '-----',
                      amount: item.amount,
                      value: item.value ? toCurrency(item.value) : 0,
                    }))
                  : []
              }
              numberRowsPerPage={10}
              progressPending={false}
            />
            <hr className="mb-0" style={{ minWidth: '1080px' }} />
            <div
              style={{
                padding: '30px 40px',
                gap: '40px',
              }}
              className="d-flex justify-content-center"
            >
              <>
                <div className="d-flex">
                  <div className="mr-1 text-small-gray-regular">Total de receitas:</div>
                  <div className="text-small-black-600">{toCurrency(sumAmountGeneral())}</div>
                </div>
              </>
            </div>
          </Card>
        </div>
        {eventState &&
          eventState.summary &&
          eventState.summary.expense &&
          eventState.summary.expense.length > 0 && (
            <div>
              <h6 className="mb-4 collapseTableText">Despesas</h6>
              <Card
                className="mb-5 card-no-border customTableScroll"
                style={{ border: 'none', overflow: 'auto' }}
              >
                <CustomTable
                  theme="secondary"
                  columns={[
                    {
                      name: 'Descrição',
                      selector: row => row.description,
                    },
                    {
                      name: 'Qtd',
                      selector: row => row.amount,
                    },
                    {
                      name: 'Valor',
                      selector: row => row.value,
                    },
                  ]}
                  data={eventState.summary.expense.map(item => ({
                    description: item.description || '-----',
                    amount: item.amount,
                    value: item.value ? toCurrency(item.value) : 0,
                  }))}
                  numberRowsPerPage={10}
                  progressPending={false}
                />
                <hr className="mb-0" style={{ minWidth: '1080px' }} />
                <div
                  style={{
                    padding: '30px 40px',
                    gap: '40px',
                  }}
                  className="d-flex justify-content-center"
                >
                  <>
                    <div className="d-flex">
                      <div className="mr-1 text-small-gray-regular">Total de receitas:</div>
                      <div className="text-small-black-600">{toCurrency(sumAmountGeneral())}</div>
                    </div>
                  </>
                </div>
              </Card>
            </div>
          )}

        <div>
          <h6 className="mb-4 collapseTableText">Fechamento Final</h6>
          <Card
            className="mb-5 card-no-border customTableScroll"
            style={{ border: 'none', overflow: 'auto' }}
          >
            <h6 className="mb-4 collapseTableText">Receitas</h6>
            <CustomTable
              theme="secondary"
              columns={[
                {
                  name: 'Descrição',
                  selector: row => row.description,
                },
                {
                  name: 'Valor',
                  selector: row => row.value,
                },
              ]}
              data={
                eventState && eventState.summary && eventState.summary.incomes
                  ? eventState.summary.incomes.map(item => ({
                      description: item.description || '-----',

                      value: item.value ? toCurrency(item.value) : 0,
                    }))
                  : []
              }
              numberRowsPerPage={10}
              progressPending={false}
            />
            <h6 className="mb-4 collapseTableText">Despesas</h6>
            <CustomTable
              theme="secondary"
              columns={[
                {
                  name: 'Descrição',
                  selector: row => row.description,
                },
                {
                  name: 'Valor',
                  selector: row => row.value,
                },
              ]}
              data={[
                {
                  description: 'Despesas  gerais',
                  value: toCurrency(
                    eventState && eventState.summary && eventState.summary.totalExpense
                      ? eventState.summary.totalExpense
                      : 0,
                  ),
                },
              ]}
              numberRowsPerPage={10}
              progressPending={false}
            />
            <hr className="mb-0" style={{ minWidth: '1080px' }} />
            <div
              style={{
                padding: '30px 40px',
                gap: '40px',
              }}
              className="d-flex justify-content-center"
            >
              <>
                <div className="d-flex">
                  <div className="mr-1 text-small-gray-regular">Valor líquido evento:</div>
                  <div className="text-small-black-600">
                    {toCurrency(
                      eventState && eventState.summary
                        ? eventState.summary.totalIncome - eventState.summary.totalExpense
                        : 0,
                    )}
                  </div>
                </div>
              </>
            </div>
          </Card>
        </div>

        <hr className="mt-5 mb-4" />
        <div className="mb-5 mt-5 report-menu-container">
          <ReportCards />
        </div>
        <div className="nextPageButton">
          <SuperButton style={{ width: '278px' }} onClick={closeEvent}>
            Fechar evento
          </SuperButton>
        </div>
      </Container>
    </Fragment>
  );
};
